// extracted by mini-css-extract-plugin
module.exports = {"container":"clients-module--container--3V2x1","flex_container":"clients-module--flex_container--1ftrN","empty_div":"clients-module--empty_div--1Om9B"};